export default __webpack_public_path__ + "static/media/org-mobile-chart.39bbba75.webp";